import React from 'react';
import { Link } from "react-router-dom";
import illustrationIntro from "../assets/images/hero2.png";
import { FaFacebookF, FaInstagram, FaGoogle, FaShieldAlt, FaChartLine, FaUsers } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const Hero = () => {
  return (
    <section id="hero">
      {/* Flex Container */}
      <div className="container flex flex-col-reverse items-center px-6 mx-auto mt-10 space-y-0 md:space-y-0 md:flex-row">
        {/* Left Item */}
        <div className="flex flex-col mb-32 space-y-8 md:w-1/2">
          <h1 className="max-w-md text-2xl font-medium text-center md:text-5xl md:text-left">
            Digitizing your group savings
          </h1>
          <p className="max-w-sm text-center md:text-left">
            Save together. Reach your goals. Strengthen community securely.
          </p>
          
          {/* Key Value Props */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <div className="flex items-center gap-2">
              <FaShieldAlt className="h-5 w-5 text-gray-600" />
              <span className="text-sm font-medium">Secure</span>
            </div>
            <div className="flex items-center gap-2">
              <FaChartLine className="h-5 w-5 text-gray-600" />
              <span className="text-sm font-medium">Transparent</span>
            </div>
            <div className="flex items-center gap-2">
              <FaUsers className="h-5 w-5 text-gray-600" />
              <span className="text-sm font-medium">Community-Driven</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <Link
              to="/community"
              className="p-3 px-6 text-white bg-gray-600 rounded-full baseline hover:bg-gray-700 text-center"
            >
              Join the Community
            </Link>
            <Link
              to="/about"
              className="p-3 px-6 text-gray-700 border border-gray-600 rounded-full baseline hover:bg-gray-100 text-center"
            >
              Learn More
            </Link>
          </div>
          <div className="flex items-center justify-center md:justify-start space-x-4">
            <a href="https://www.facebook.com/ajoapp_ca" target="_blank" rel="noopener noreferrer">
              <FaFacebookF className="h-6 w-6 text-gray-700 hover:text-gray-900" aria-label="Facebook" />
            </a>
            <a href="https://www.instagram.com/ajoapp_ca" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="h-6 w-6 text-gray-700 hover:text-gray-900" aria-label="Instagram" />
            </a>
            <a href="https://x.com/ajoapp_ca" target="_blank" rel="noopener noreferrer">
              <FaXTwitter className="h-6 w-6 text-gray-700 hover:text-gray-900" aria-label="X" />
            </a>
            <a href="https://share.google/nG2rnvWbJWHnzMCaD" target="_blank" rel="noopener noreferrer">
              <FaGoogle className="h-6 w-6 text-gray-700 hover:text-gray-900" aria-label="Google" />
            </a>
          </div>
        </div>
        <div className='md:w-1/2 flex justify-center items-center h-full'>
            <img
              src={illustrationIntro}
              alt='illustration'
              className='w-full h-fit object-cover rounded-md'
              loading='lazy'
            />
        </div>
      </div>
    </section>
  );
};

export default Hero;
